import ListView from "../../component/ListView";
import {Column} from "primereact/column";
import rest from "../../utils/EnvConfig";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import SemPermissao from "../erro/SemPermissao";

function TipoRestauranteList() {
    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}
                             forbiddenFallback={<SemPermissao />}>
                <ListView title={"Tipo restaurante"}
                          id={`${rest.tipoRestaurante}`}>
                    <Column field="nomeAtividade" header="Descrição" sortable />
                </ListView>
            </RoleBasedAccess>
        </>
    );
}

export default TipoRestauranteList;